import { execute } from '@tutorabc/webview-jsbridge'

// constants
import { BRIDGE_HANDLER } from '@/constants/bridgeHandler'
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'
import { ROUTE_PATH } from '@/constants/routePath'
import { envConfigs } from '@/constants/config'

interface IEnterLiveRoom {
  roomId: string
  liveType: number
  liveSourceType?: number
  locale?: string
}

export const enterRoom = ({ roomId, liveType = ROOM_LIVE_TYPE.DEFAULT, liveSourceType, locale }: IEnterLiveRoom) => {
  const isPast = liveType === ROOM_LIVE_TYPE.PAST
  if (isPast) {
    execute({
      handlerName: BRIDGE_HANDLER.OPEN_WEB_VIEW,
      data: {
        url: `${envConfigs.domainUrl}${locale ? `/${locale}` : ''}${ROUTE_PATH.LIVE}/${roomId}`,
        showNavigation: true,
      },
    })
    return
  }

  execute({
    handlerName: BRIDGE_HANDLER.OPEN_ROOM,
    data: {
      id: roomId,
      liveType,
      liveSourceType,
    },
  })
}
